import { useState } from 'react';

export interface QueueMethods<T> {
  add: (item: T) => void;
  remove: (item?: T) => T;
  reset: () => void;
  list: T[];
  first: T;
  last: T;
  size: number;
}

export function useQueue<T>(initialQueue: T[] = []): QueueMethods<T> {
  const [queue, setQueue] = useState(initialQueue);

  const add = (item: T) => {
    setQueue(items => [...items, item]);
  };

  const remove = (item?: T) => {
    let result = item;

    if (item) {
      setQueue(items => items.filter(value => value !== item));
    } else {
      setQueue(([first, ...rest]) => {
        result = first;
        return rest;
      });
    }

    return result as T;
  };

  const reset = () => {
    setQueue(initialQueue);
  };

  return {
    add,
    remove,
    reset,
    list: queue,
    size: queue.length,
    first: queue[0],
    last: queue[queue.length - 1]
  };
}
